import React, { useContext, useState } from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col } from "react-bootstrap";
import { Button, BreadCrumb } from "@atoms";
import { TextField } from "@molecules";
import { useMutation } from "@apollo/react-hooks";
import { CUSTOMER_CHANGE_PASSWORD } from "@components/pages/ChangePasswordPage/queries";
import { customerChangePassword } from "@components/pages/ChangePasswordPage/__generated__/customerChangePassword";
import { CredentialContext, credentialType } from "@providers";
import { useAlert } from "react-alert";
import { history } from "@src/history";
import { baseUrl, accountUrl } from "@src/app/routes";

const ChangePasswordPage: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  const {currentUser} = useContext<credentialType>(CredentialContext);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const alert = useAlert();
  const [changeCustomerPassword] =
    useMutation<customerChangePassword>(CUSTOMER_CHANGE_PASSWORD, {
      onCompleted: (data) => {
        const errors = data?.customerChangePassword?.errors;
        if (errors.length) {
          alert.error(errors[0].message);
        } else {
          alert.success("Password Changed.");
          history.push(baseUrl);
        }
      }
    });
  const handleClick = (e:any) => {
    changeCustomerPassword({
      variables: {
        id: currentUser.user.id,
        input: {
          oldPassword, newPassword
        }
      }
    })
  }

  const breadCrumbData = [
    {
      name: "My Account",
      link: accountUrl
    },
    {
      name: "Change Password"
    }
  ]

  return (
    <Container>
      <BreadCrumb
        data={breadCrumbData}
      />
      <Row>
        <Col md={{span: 8, offset: 2}}>
          <TextField
            name="oldPassword"
            type="password"
            required
            label="Old Password"
            value={oldPassword}
            onChange={(e:any) => {setOldPassword(e.target.value)}}
          />
          <TextField
            name="newPassword"
            type="password"
            required
            label="New Password"
            value={newPassword}
            onChange={(e:any) => {setNewPassword(e.target.value)}}
          />
          <Button onClick={handleClick}>Change Password</Button>
        </Col>
      </Row>
    </Container>
  )
};

export { ChangePasswordPage }